import { render, staticRenderFns } from "./AscPageFixedFooter.vue?vue&type=template&id=1b54439b&"
import script from "./AscPageFixedFooter.vue?vue&type=script&lang=js&"
export * from "./AscPageFixedFooter.vue?vue&type=script&lang=js&"
import style0 from "./AscPageFixedFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports